

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"viewBox":"0 0 8 5"}, rest), ["\n  ", h('path', {"fill":"currentColor","fill-rule":"nonzero","d":"M6.877.522a.675.675 0 0 1 1.025.872l-.071.084-3.177 3.168a.675.675 0 0 1-.87.07l-.084-.07L.523 1.478a.675.675 0 0 1 .87-1.027l.084.071 2.7 2.693 2.7-2.693Z"}, []), "\n"]);
};

        